import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './interstitialAd.css';


export default class InterstitialAd extends Component {
  
  constructor(props) {
    super(props);

    this.onAdsManagerLoaded = this.onAdsManagerLoaded.bind(this);
    this.onContentPauseRequested = this.onContentPauseRequested.bind(this);
    this.onContentResumeRequested = this.onContentResumeRequested.bind(this);
    this.onAdEvent = this.onAdEvent.bind(this);
  }    

  componentDidMount() { 
    this.showAd();
  }
  
  showAd() {
    var self = this;
    var addScript = document.createElement('script');
    addScript.setAttribute('src', '//imasdk.googleapis.com/js/sdkloader/ima3.js');
    document.body.appendChild(addScript);

    addScript.onload = function() {
        self.setupWidthAndHeight();
        self.setUpIMA();
    };  

    addScript.onerror = function() {
        self.props.adFinished();
    }
  }

  setupWidthAndHeight() {
      this.w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      this.h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      if(this.w >= 960){
        this.w = 800;
        this.h = 500;
      }

      if (this.props.small) {
        this.w = 450;
        this.h = 300;
      }
  }

  setUpIMA() {
      // Create the ad display container.
      this.createAdDisplayContainer();
      // Create ads loader.
      this.adsLoader = new window.google.ima.AdsLoader(this.adDisplayContainer);
      // Listen and respond to ads loaded and error events.
      this.adsLoader.addEventListener(
          window.google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
          this.onAdsManagerLoaded,
          false);
      this.adsLoader.addEventListener(
          window.google.ima.AdErrorEvent.Type.AD_ERROR,
          this.onAdError,
          false);

      // An event listener to tell the SDK that our content video
      // is completed so the SDK can play any post-roll ads.
      var contentEndedListener = function () { this.adsLoader.contentComplete(); };
      this.videoContent.onended = contentEndedListener;

      // Request video ads.
      var adsRequest = new window.google.ima.AdsRequest();
      adsRequest.adTagUrl = 'https://googleads.g.doubleclick.net/pagead/ads?ad_type=video_image&client=ca-games-pub-6347738353793988&videoad_start_delay=0&description_url=http%3A%2F%2Fwww.higherlowergame.com&max_ad_duration=20000';
      adsRequest.forceNonLinearFullSlot = true;

      
      // Specify the linear and nonlinear slot sizes. This helps the SDK to
      // select the correct creative if multiple are returned.
      adsRequest.linearAdSlotWidth = this.w;
      adsRequest.linearAdSlotHeight = this.h;

      adsRequest.nonLinearAdSlotWidth = this.w;
      adsRequest.nonLinearAdSlotHeight = this.h;

      this.adsLoader.requestAds(adsRequest);
  }

  createAdDisplayContainer() {
      // We assume the adContainer is the DOM id of the element that will house
      // the ads.
      this.adDisplayContainer = new window.google.ima.AdDisplayContainer(
          this.adContainer, this.videoContent);
  }

  playAds() {
      // Initialize the container. Must be done via a user action on mobile devices.
      this.adDisplayContainer.initialize();
      this.videoContent.load();
      
      try {
          // Initialize the ads manager. Ad rules playlist will start at this time.
          this.adsManager.init(this.w, this.h, window.google.ima.ViewMode.NORMAL);
          // Call play to start showing the ad. Single video and overlay ads will
          // start at this time; the call will be ignored for ad rules.
          this.adsManager.start();
      } catch (adError) {
          // An error may be thrown if there was a problem with the VAST response.
          
          this.restartGame();
          //videoContent.play();
      }
  }

  onAdsManagerLoaded(adsManagerLoadedEvent) {
      // Get the ads manager.
      var adsRenderingSettings = new window.google.ima.AdsRenderingSettings();
      adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;
      // videoContent should be set to the content video element.

      this.adsManager = adsManagerLoadedEvent.getAdsManager(
        this.videoContent, adsRenderingSettings);

      // Add listeners to the required events.
      this.adsManager.addEventListener(
          window.google.ima.AdErrorEvent.Type.AD_ERROR,
          this.onAdError);
      this.adsManager.addEventListener(
          window.google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
          this.onContentPauseRequested);
      this.adsManager.addEventListener(
          window.google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
          this.onContentResumeRequested);
      this.adsManager.addEventListener(
          window.google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
          this.onAdEvent);
      this.adsManager.addEventListener(
          window.google.ima.AdEvent.Type.CLICK,
          this.onAdEvent);

      // Listen to any additional events, if necessary.
      this.adsManager.addEventListener(
          window.google.ima.AdEvent.Type.LOADED,
          this.onAdEvent);
      this.adsManager.addEventListener(
          window.google.ima.AdEvent.Type.STARTED,
          this.onAdEvent);
      this.adsManager.addEventListener(
          window.google.ima.AdEvent.Type.COMPLETE,
          this.onAdEvent);
      this.adsManager.addEventListener(
          window.google.ima.AdEvent.Type.USER_CLOSE,
          this.onAdEvent);

      this.playAds();
  }

  onAdEvent(adEvent) {
      // Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
      // don't have ad object associated.
      var ad = adEvent.getAd();
      switch (adEvent.type) {
          case window.google.ima.AdEvent.Type.LOADED:
              // This is the first event sent for an ad - it is possible to
              // determine whether the ad is a video ad or an overlay.
              if (!ad.isLinear()) {
                  // Position AdDisplayContainer correctly for overlay.
                  // Use ad.width and ad.height.
                  this.restartGame();
                  //videoContent.play();
              }
              break;
          case window.google.ima.AdEvent.Type.STARTED:
              // This event indicates the ad has started - the video player
              // can adjust the UI, for example display a pause button and
              // remaining time.
              if (ad.isLinear()) {
                  // For a linear ad, a timer can be started to poll for
                  // the remaining time.
                  this.intervalTimer = setInterval(
                      function () {
                          //var remainingTime = self.adsManager.getRemainingTime();
                      },
                      300); // every 300ms
              }
              break;
          case window.google.ima.AdEvent.Type.COMPLETE:
              // This event indicates the ad has finished - the video player
              // can perform appropriate UI actions, such as removing the timer for
              // remaining time detection.
              if (ad.isLinear()) {
                  clearInterval(this.intervalTimer);
              }
              break;
          case window.google.ima.AdEvent.Type.USER_CLOSE:
              this.restartGame();
              break;
        default:
            break;
      }
  }

  onAdError(adErrorEvent) {
      // Handle the error logging.
      if (this.adsManager !== undefined) {
        this.adsManager.destroy();
      }
  }

  onContentPauseRequested() {
    this.videoContent.pause();
      // This function is where you should setup UI for showing ads (e.g.
      // display ad timer countdown, disable seeking etc.)
      // setupUIForAds();
  }

  onContentResumeRequested() {
    this.restartGame();
      //videoContent.play();

      // This function is where you should ensure that your UI is ready
      // to play content. It is the responsibility of the Publisher to
      // implement this function when necessary.
      // setupUIForContent();

  }

  restartGame() {
      this.props.adFinished();
  }


  render() {
    return (
      <div id='adPopup' className={this.props.small ? 'adPopup adPopup_small' : 'adPopup'} ref={ref => this.adPopup = ref} >
        <div id='content' className={this.props.small ? 'content content_small' : 'content'}>
          <video id='contentElement' className={this.props.small ? 'contentElement contentElement_small' : 'contentElement'} ref={ref => this.videoContent = ref}  />
        </div>
        <div id='adContainer' className={this.props.small ? 'adContainer adContainer_small' : 'adContainer'} ref={ref => this.adContainer = ref} />
      </div>
    );
  }
}

InterstitialAd.propTypes = {
  adFinished: PropTypes.func,
  small: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/interstitial-ad/interstitialAd.js